import React from 'react'
import { StyledFBLoginButton } from './Button.styled'
import { connect } from 'react-redux'

const FBLoginButton = ({ onLogin, ...props }) => (
  <StyledFBLoginButton onClick={onLogin} {...props}>
    Facebook 登入
  </StyledFBLoginButton>
)

const mapDispatch = ({ auth }) => ({
  onLogin: () => auth.signInWithFacebook()
})

export default connect(null, mapDispatch)(FBLoginButton)


// WEBPACK FOOTER //
// ./src/components/Button/FBLoginButton.js